// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3KKFB","productName":"Table_productName__25rHJ"};